import fetch from '../utils/http';


/**
 * 1. 查询详情-招标项目
 * 
 * @params { Object } params 参数集
{
 
}
 */
export function query(params) {
    const data = Object.assign({}, {}, params);
    return fetch.get({
        url: "/ifbcontent/getContent",
        data
    })
}


/**
 * 2. 招标文件-查询分页
 * 
 * @params { Object } params 参数集
{
 
}
 */
export function queryPageSolrfile(params) {
    const data = Object.assign({}, {}, params);
    return fetch.post({
        url: "/ifbreferral/queryPage",
        data
    })
}


/**
 *3. 查询招标文件
 * 
 * @params { Object } params 参数集
{
 
}
 */
export function getList(params) {
    const data = Object.assign({}, {}, params);
    return fetch.get({
        url: "/ifbfile/getList",
        data
    })
}


/**
   * 4. 招标项目标题-模板列表
   * 
   * @params { Object } params 参数集
  {
   
  }
   */
export function temList(params) {
    const data = Object.assign({}, {}, params);
    return fetch.get({
        url: "/ifbkwdtemplate/getList",
        data
    })
}